<template>
  <v-sheet class="pa-2">
    <div class="d-flex align-center">
      <div class="flex-fill">
        <v-text-field
          id="messageInput"
          type="text"
          placeholder="Enviar un mensaje"
          filled
          dense
          rounded
          hide-details
          color="primary"
          v-model="message"
          v-on:keyup.enter="send()"
          focus
          :disabled="disabled"
          class="message-field"
        ></v-text-field>
      </div>
      <div class="pl-1">
        <v-btn
          icon
          color="primary"
          @click="send()"
          :disabled="!message"
        >
          <Icon
            :width="24"
            :color="'rgba(0,0,0,.54)'"
            :icon="'send'"
          />
        </v-btn>
      </div>
    </div>
  </v-sheet>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue')
  },
  props: {
    disabled: {
      type: Boolean,
      default: true
    }
  }
})
export default class TextField extends Vue {
  data () {
    return {
      message: ''
    }
  }

  send () {
    if (!this.message) {
      return false
    }

    this.$emit('sendMessage', this.message)
    this.message = ''
  }
}
</script>

<style>
  .message-field{
    font-size: 14px;
  }
</style>
